module.exports = __webpack_public_path__ + "img/mlk linda page 1.e8132606.jpg";